const products = document.querySelector('#MainContent');
const swiperClass = products.querySelectorAll('.swiper');

var recSwiperArray = [];
var recClass;
var recPag;
for (var i = 0; i < swiperClass.length; ++i) {
  recClass = '.recommendations-product-' + i;
  recPag = '.swiper-pagination.recprod-' + i;
  recSwiperArray[i] = new Swiper(recClass, {
    slidesPerView: 1,
    pagination: {
      el: recPag,
      clickable: true,
    }
  });
};